module.exports = __webpack_public_path__ + "img/receivablesCode.4fbbf713.png";